"use client";

import { translations } from "@/messages";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
const LanguageChangeNotice = () => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const fromLanguage = queryParams.get("fl") as keyof typeof translations || null;
    const toLanguage = queryParams.get("tl") as keyof typeof translations || null;
    if (fromLanguage && toLanguage) {
      toast.info(<div className="flex flex-col">
          <div className="text-sm">
            {translations[fromLanguage]["institution"]["languageChangeNotice"]}
          </div>
        </div>, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true
      });
    }
  }, []);
  return <></>;
};
export default LanguageChangeNotice;